import axios from "axios";
import AuthService from "@/services/auth.service";

const laravelApiClient = axios.create({
  baseURL: process.env.VUE_APP_QUEUE_API,
  withCredentials: true,
});

laravelApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (!error.response || error.response.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;
    try {
      const newTokens = await AuthService.refreshToken();

      originalRequest.headers['Authorization'] = `Bearer ${newTokens.lar_token}`;

      return laravelApiClient(originalRequest);
    } catch (refreshError) {
      AuthService.logout();
      return Promise.reject(refreshError);
    }
  }
);
export default laravelApiClient;
